<!--  Here the specific settings component content is hosted!-->
<ng-template componentHost></ng-template>
